// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * File icon with list lines (import document).
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function ImportIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14 13h2" />
      <path d="M14 17h2" />
      <path d="M14 2v5a1 1 0 0 0 1 1h5" />
      <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
      <path d="M8 13h2" />
      <path d="M8 17h2" />
      <path d="M8 9h2" />
    </svg>
  );
}
